import { Polyline } from 'react-leaflet';
import { useTheme } from '@querodelivery/uni-react';
import {
  ROUTE_LINE_DASH_ARRAY,
  ROUTE_LINE_OPACITY,
  ROUTE_LINE_WEIGHT,
} from './constants';
import type { MapPosition } from '../types';
import styles from './route-line.module.scss';

interface RouteLineParams {
  from: MapPosition;
  to: MapPosition;
}

export const RouteLine = ({ from, to }: RouteLineParams) => {
  const { color } = useTheme();

  return (
    <Polyline
      positions={[from, to]}
      className={styles.routeLine}
      pathOptions={{
        color: color['color-action-fill'],
        weight: ROUTE_LINE_WEIGHT,
        opacity: ROUTE_LINE_OPACITY,
        dashArray: ROUTE_LINE_DASH_ARRAY,
        lineCap: 'round',
      }}
    />
  );
};
